/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-10-12 15:37:24
 */
import router from './router'
import store from './store/index.js'
import cookie from './utils/cookie.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 加载进度条
NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })
// 白名单
const whiteList = ['/', '/staffFirstLogin']

/**
 * 校验动态业务页依赖的活动上下文。
 * Cookie 可以跨标签页存在，而 sessionStorage 可能为空；只检查 token/perms 会让新标签页
 * 直接进入父布局并读取空 activityInfo。下载页还必须具备 groupId，才能限定分组数据。
 */
const hasRequiredActivityContext = path => {
  const activityId = sessionStorage.getItem('activityId')
  const groupId = sessionStorage.getItem('groupId')
  let activityInfo = null
  try {
    activityInfo = JSON.parse(sessionStorage.getItem('activityInfo') || 'null')
  } catch (error) {
    return false
  }
  if (!activityId || !activityInfo || typeof activityInfo !== 'object' || Array.isArray(activityInfo)) {
    return false
  }
  const hasGroupId = groupId !== null && groupId !== '' && groupId !== 'null' && groupId !== 'undefined'
  return path !== '/download' || hasGroupId
}

/**
 * 清理不完整/损坏的登录状态并完成当前导航，避免守卫 catch 后既不 next 也不回退，
 * 页面永久停在进度条。清理前保留仍可用的活动入口参数，方便用户重新登录。
 */
const resetInvalidSessionAndRedirect = async (next) => {
  const activityId = sessionStorage.getItem('activityId')
  const from = sessionStorage.getItem('from')
  const loginPath = activityId && from
    ? `/?activity_id=${encodeURIComponent(activityId)}&form=${encodeURIComponent(from)}`
    : '/'
  cookie.clearAuthCookies()
  sessionStorage.clear()
  await store.dispatch('permission/resetRoutes')
  await store.dispatch('user/commitChangeRole', null)
  NProgress.done()
  next(loginPath)
}

router.beforeEach(async (to, from, next) => {
  if (/\/[0-9]+\/[a-z_]+/.test(to.path)) {
    const paramsArr = to.path.split('/').filter(item => item !== '')
    next(`/?activity_id=${paramsArr[0]}&form=${paramsArr[1]}`)
    return
  }
  NProgress.start()
  const token = cookie.getCookie('token')
  const role = cookie.getCookie('perms')
  // const sysType = localStorage.getItem('sysType')
  if (token && role) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      if (!hasRequiredActivityContext(to.path)) {
        await resetInvalidSessionAndRedirect(next)
        return
      }
      // 登录过
      const hasRole = store.state.user.role
      if (hasRole) {
        next()
      } else {
        try {
          // await store.dispatch('uiPermisson/genaraterSys', sysType)
          const accessRouter = await store.dispatch(
            'permission/getAsyncRoutes',
            role
          )
          await store.dispatch('user/commitChangeRole', role)
          router.addRoutes(accessRouter)
          next({ ...to, replace: true })
          // next()
        } catch (error) {
          console.error('动态路由初始化失败', error)
          await resetInvalidSessionAndRedirect(next)
        }
      }
    }
  } else {
    // 未登录
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next({ path: '/' })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js